import { once } from 'lodash';

import { createStorage } from '@sg/mmkv-storage';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfBagFeaturedUpsellSessionEligible(sessionInterval: number) {
  const currentSession = getCurrentSession();
  const lastShownSession = getNumber(SHOWN_SESSION_KEY);
  const hasShownBefore = lastShownSession > 0;
  const sessionsSinceShown = currentSession - lastShownSession;
  const isSnoozed = currentSession < getNumber(SNOOZED_UNTIL_SESSION_KEY);
  const isDue = !hasShownBefore || sessionsSinceShown >= sessionInterval;

  return sessionInterval > 0 && !isSnoozed && isDue;
}

export function markBagFeaturedUpsellShown() {
  STORAGE.set(SHOWN_SESSION_KEY, getCurrentSession());
}

export function markBagFeaturedUpsellDismissed() {
  const snoozedUntilSession = getCurrentSession() + DISMISSED_SKIPPED_SESSIONS + 1;

  STORAGE.set(SNOOZED_UNTIL_SESSION_KEY, snoozedUntilSession);
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

// A session is one app launch (one page load on web), counted on first read.
const getCurrentSession = once(startSession);

function startSession() {
  const currentSession = getNumber(SESSION_COUNT_KEY) + 1;

  STORAGE.set(SESSION_COUNT_KEY, currentSession);

  return currentSession;
}

function getNumber(key: string) {
  return STORAGE.getNumber(key) ?? 0;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const STORAGE = createStorage({ id: 'sg.bag-featured-upsell' });

const SESSION_COUNT_KEY = 'session_count';
const SHOWN_SESSION_KEY = 'shown_session';
const SNOOZED_UNTIL_SESSION_KEY = 'snoozed_until_session';

const DISMISSED_SKIPPED_SESSIONS = 3;
